<template>
    <div>
        <el-row class="">
            <el-col>
                <div class="table-grd">
                    <div class="header">
                        <h1>{{ $t('Manage Email Templates') }}</h1>
                        <ul class="icon-list">
                            <!-- <li>
                                <router-link :to="{name: 'CreateEmailTemplate'}">
                                    <i class="icon-add"></i>
                                </router-link>
                            </li> -->
                        </ul>
                    </div>
                    <v-collapse-group ref="group1">
                        <v-collapse-wrapper ref="toggle_second">
                            <div class="my-content table-desc">
                                <el-table :data="emailTemplates.data" @sort-change="handleSortChange" fit highlight-current-row key='aTable'>
                                    <el-table-column :label="$t('No.')" type="index" :index="indexMethod" width="60" fixed></el-table-column>
                                    <el-table-column :label="$t('Actions')" colspan="2" width="100" fixed>
                                        <template slot-scope="scope">
                                            <ul class="act-list">
                                                <li v-if="$store.getters.getConfig('has_permissions').includes('patenkinders-cases-store')">
                                                    <a href="javascript:void(0);" @click="handleEdit(scope.row.slug)"><i class="icon-edit"></i></a>
                                                </li>
                                            </ul>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Title')" sortable="custom" prop="title" width="650">
                                    </el-table-column>
                                    <el-table-column :label="$t('Status')" prop="status" width="250">
                                        <template slot-scope="scope">
                                            <label :class="(scope.row.status == 'active'? 'act': 'in-act')">{{
                                                $t(scope.row.status) }}</label>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Created at')" prop="created_at" width="300">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.updated_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column :label="$t('Modified at')" prop="updated_at" width="300">
                                        <template slot-scope="scope">
                                            <span v-date-time-format="scope.row.updated_at"></span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column min-width="10"></el-table-column>
                                </el-table>
                                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filterData.page" :page-sizes="[6, 12, 24, 66, 111]" :page-size="filterData.pageLength" layout="sizes, slot, ->, prev, pager, next" :total="emailTemplates.meta.total">
                                    <template>
                                        <span class="page-no">{{ $t('Showing out of records',{'0':
                                            emailTemplates.data.length, '1': emailTemplates.meta.total}) }}</span>
                                    </template>
                                </el-pagination>
                            </div>
                        </v-collapse-wrapper>
                    </v-collapse-group>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import moment from "moment";
    import moment_timezone from 'moment-timezone';
    export default {
        data() {
            return {
                filterData: {
                    page: 1,
                    pageLength: process.env.KIPAKI_pageLength,
                    sortBy: "id",
                    order: "desc"
                },
                dialogFormVisible: false,
                formLabelWidth: "120px",
                emailTemplates: {
                    meta: {},
                    data: []
                }
            };
        },
        mounted() {
            this.getEmailTemplates();
        },
        methods: {
            dateTimeFormat(dateTime) {
                return helper.getDateTimeFormat(dateTime);
            },
            getEmailTemplates() {
                request({
                    url: "email-templates",
                    method: "get",
                    params: this.filterData
                }).then(response => (this.emailTemplates = response.data));
            },
            handleEdit(slug) {
                this.$router.push("/email-templates/" + slug + "/edit");
            },
            handleCurrentChange(event) {
                this.getEmailTemplates(this.filterData.current_page);
            },
            handleSizeChange(event) {
                this.filterData.pageLength = event;
                this.getEmailTemplates();
            },
            handleSortChange(event) {
                this.filterData.sortBy = event.prop;
                if (event.order === "ascending") this.filterData.order = "asc";
                else if (event.order === "descending") this.filterData.order = "desc";
                else {
                    this.filterData.sortBy = "id";
                    this.filterData.order = "desc";
                }
                this.getEmailTemplates();
            },
            indexMethod(index) {
                return (
                    index +
                    this.filterData.pageLength * this.filterData.page -
                    this.filterData.pageLength +
                    1
                );
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.getEmailTemplates();
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/Layout/EmailTemplates/EmailTemplate.vue